import { BuyerJobList } from '@features/buyer/jobs/buyer-job-row';
import {
  defaultJobListFilter,
  type JobListFilter,
} from '@features/jobs';
import { useBuyerCurrentJobsQuery } from '@lib/api/jobs';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import type { BuyerCurrentJob } from './currentJobTypes';

interface CurrentJobProps {
  search?: string;
  filter?: JobListFilter;
  filtering?: boolean;
}

const CurrentJob = ({
  search = '',
  filter = defaultJobListFilter,
  filtering = false,
}: CurrentJobProps): JSX.Element => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const {
    jobs,
    isPending,
    isFetching,
    isFetchingNextPage,
    hasNextPage,
    fetchNextPage,
  } = useBuyerCurrentJobsQuery(search, filter);
  const searching = Boolean(search);
  const loading =
    isPending ||
    (isFetching && (searching || filtering) && !isFetchingNextPage);

  const emptyTitle = searching
    ? t('jobs.emptySearchTitle')
    : filtering
      ? t('jobs.emptyFilterTitle')
      : t('jobs.emptyCurrentTitle');
  const emptyHint = searching
    ? t('jobs.emptySearchHint', { query: search })
    : filtering
      ? t('jobs.emptyFilterHint')
      : t('jobs.emptyCurrentHint');

  return (
    <BuyerJobList
      jobs={jobs as BuyerCurrentJob[]}
      loading={loading}
      searching={searching || filtering}
      emptyTitle={emptyTitle}
      emptyHint={emptyHint}
      hasNextPage={Boolean(hasNextPage)}
      isFetchingNextPage={isFetchingNextPage}
      onLoadMore={() => {
        void fetchNextPage();
      }}
      onOpen={(job) =>
        navigate('/job-detail', { state: { currentJobData: job } })
      }
    />
  );
};

export default CurrentJob;
